<template>
    <div class="twoBannerHome wow fadeInAnimated fadeIn">
        <div class="title">
            <img :src="haojobLogo" alt="">
            <ul class="tabItem">
                <li @click="$router.push('/')">首页</li>
                <li @click="$router.push('/investment')" class="active">招商加盟</li>
                <li @click="$router.push('/downloadApp')">APP下载</li>
                <li @click="$router.push('/relationPages')">联系我们</li>
                <li style="width: 100px;height: 35px;background: #FFFFFF;border: 1px solid #1D5EEA;line-height:35px;text-align: center;margin-top:22.5px;padding:0;"><a style="color:#1D5EEA;text-decoration: none;" href="http://consoletwo.lielanghr.com/#/login">劳务登录</a></li>
            </ul>
        </div>
        <div class="centerFloat">
            <div class="textCont">
                <dl v-for="(item,index) in newList" :key="index" @click="$router.push(`/newDetail/${item.id}`)">
                    <dt>
                        <img :src="JSON.parse(item.coverUrl)[0].url" alt="">
                    </dt>
                    <dd>
                        <span class="ddTitle">{{item.tutorialTitle}}</span>
                        <span class="contentTextCent" v-html="item.tutorialContent"></span>
                        <span class="time">{{getTime(item.createTime,'分')}}</span>
                    </dd>
                </dl>
            </div>
            <div class="seeMore" v-if="newSeeMore" @click="seeMoreDate">查看更多</div>
        </div>
        <footerPages :backColor="'#3A3D53'" :borderBottom="'1px solid #626475'"></footerPages>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
import haojobLogo from '@/assets/haoojoblogo.svg'
import contactus from '@/assets/download/contactus-map@2x.png'
import api from '@/api'

export default {
    data(){
        return {
            haojobLogo,
            contactus,
            newList:[],
            newSeeMore:false,
            query:{
                pageNum:1,
                pageSize:5
            },
            totalPages:''
        }
    },
    mounted () {
        let wow = new WOW({
                boxClass: 'wow',
                animateClass: 'animated',
                offset: 0,
                mobile: true
        })
        wow.init();
    },
    methods:{
        getTime(time,type) {
            var y = new Date(time).getFullYear();
            var m = new Date(time).getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = new Date(time).getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = new Date(time).getHours();
            var minute = new Date(time).getMinutes();
            minute = minute < 10 ? ('0' + minute) : minute;
            if(type=='分'){
            return y + '年' + m + '月' + d+'日 '+h+':'+minute;
            }else if(type=='月'){
            return y + '年' + m + '月'
            }else if(type=='日'){
            return y + '年' + m + '月' + d+'日 '
            }
        },
        async initData(){
            let res = await api.newList(this.query)
            if(res.totalSize>5){//如果数据有5条以上，才显示新闻更多按钮
                this.newSeeMore=true
            }else{
                this.newSeeMore=false
            }
            if(this.totalPages==this.query.pageNum){
                this.newSeeMore = false
            }
            var newchilds=res.content;
            this.totalPages = res.totalPages
            this.newList = this.newList.concat(newchilds)
        },
        async seeMoreDate(){
            this.query.pageNum+=1
            this.initData()
        }
    },
    created(){
        this.initData()
    },
}
</script>
<style src='@/pages/components/publicStyle/animated.css' scoped></style>
<style scoped lang="less">
    .centerFloat{
        width: 100%;
        height: auto;
        background: #F3F5F8;
        overflow: hidden;
        box-sizing: border-box;
        .textCont{
            width: 1200px;
            height: auto;
            padding-top: 53px;
            box-sizing: border-box;
            overflow: hidden;
            margin: 0 auto;
            cursor: pointer;
            dl{
                width: 100%;
                display: block;
                overflow: hidden;
                float: right;
                background: #fff;
                margin-bottom: 30px;
                dt{
                    width: 400px;
                    height: 200px;
                    display: block;
                    float: left;
                    margin-right: 32px;
                    img{
                        display: block;
                        width: 400px;
                        height: 200px;
                    }
                }
                dd{
                    display: block;
                    float: left;
                    width: 728px;
                    padding-top: 25px;
                    box-sizing: border-box;
                    span{
                        display: block;
                    }
                    .ddTitle{
                        font-size:24px;
                        font-weight:400;
                        color:rgba(33,33,33,1);
                        line-height:36px;
                        margin-bottom: 20px;
                    }
                    .contentTextCent{
                        font-size:14px;
                        font-weight:400;
                        color:rgba(101,101,101,1);
                        line-height: 21px;
                        margin-bottom: 20px;
                        word-break:break-all;
                        display:-webkit-box;/**对象作为伸缩盒子模型展示**/
                        -webkit-box-orient:vertical;/**设置或检索伸缩盒子对象的子元素的排列方式**/
                        -webkit-line-clamp:2;/**显示的行数**/
                        overflow:hidden;/**隐藏超出的内容**/
                    }
                    .time{
                        font-size:12px;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        line-height:24px;
                    }
                }
            }
        }
        .seeMore{
            width: 600px;
            height:56px;
            background:rgba(255,255,255,1);
            font-size:18px;
            font-weight:400;
            color:rgba(29,93,233,1);
            line-height: 56px;
            text-align: center;
            margin: 0 auto;
            margin-top: 19px;
            margin-bottom: 102px;
            cursor: pointer;
        }
    }
    @media only screen and (max-width: 1024px) {
        .centerFloat{
            .textCont{
                width: 640px;
                padding-top: 44px;
                dl{
                    margin-bottom: 16px;
                    dt{
                        width: 213px;
                        height: 107px;
                        margin-right: 17px;
                        img{
                            width: 213px;
                            height: 107px;
                        }
                    }
                    dd{
                        width: 388px;
                        padding-top: 16px;
                        .ddTitle{
                            font-size: 13px;
                            line-height: 19px;
                            margin-bottom: 11px;
                        }
                        .contentTextCent{
                            font-size: 7px;
                            line-height: 13px;
                            margin-bottom: 11px;
                        }
                        .time{
                            font-size: 6px;
                            line-height: 13px;
                        }
                    }
                }
            }
            .seeMore{
                width:320px;
                height:30px;
                line-height: 30px;
                font-size:10px;
                margin-top: 9px;
                margin-bottom: 54px;
            }
        }
    }

    @media only screen and (max-width: 1100px) and (min-width: 1024px) {
        .centerFloat{
            .textCont{
                width: 688px;
                padding-top: 48px;
                dl{
                    margin-bottom: 17px;
                    dt{
                        width: 229px;
                        height: 115px;
                        margin-right: 18px;
                        img{
                            width: 229px;
                            height: 115px;
                        }
                    }
                    dd{
                        width: 417px;
                        padding-top: 17px;
                        .ddTitle{
                            font-size: 14px;
                            line-height:21px;
                            margin-bottom: 12px;
                        }
                        .contentTextCent{
                            font-size:8px;
                            line-height: 14px;
                            margin-bottom: 11px;
                        }
                        .time{
                            font-size: 7px;
                            line-height: 14px;
                        }
                    }
                }
            }
            .seeMore{
                width:344px;
                height:32px;
                line-height: 32px;
                font-size:10px;
                margin-top: 9px;
                margin-bottom: 58px;
            }
        }
    }

    @media only screen and (max-width: 1280px) and (min-width: 1100px) {
        .centerFloat{
            .textCont{
                width: 800px;
                padding-top: 55px;
                dl{
                    margin-bottom: 20px;
                    dt{
                        width: 267px;
                        height: 133px;
                        margin-right: 21px;
                        img{
                            width: 267px;
                            height: 133px;
                        }
                    }
                    dd{
                        width: 485px;
                        padding-top: 20px;
                        .ddTitle{
                            font-size: 16px;
                            line-height:24px;
                            margin-bottom: 14px;
                        }
                        .contentTextCent{
                            font-size:9px;
                            line-height: 16px;
                            margin-bottom: 13px;
                        }
                        .time{
                            font-size: 8px;
                            line-height: 16px;
                        }
                    }
                }
            }
            .seeMore{
                width:400px;
                height:37px;
                line-height: 37px;
                font-size:12px;
                margin-top: 13px;
                margin-bottom: 68px;
            }
        }
    }

    @media only screen and (max-width: 1366px) and (min-width: 1280px) {
        .centerFloat{
            .textCont{
                width: 854px;
                padding-top: 59px;
                dl{
                    margin-bottom: 21px;
                    dt{
                        width: 285px;
                        height: 142px;
                        margin-right: 23px;
                        img{
                            width: 285px;
                            height: 142px;
                        }
                    }
                    dd{
                        width: 518px;
                        padding-top: 21px;
                        .ddTitle{
                            font-size: 17px;
                            line-height:26px;
                            margin-bottom: 15px;
                        }
                        .contentTextCent{
                            font-size:10px;
                            line-height: 17px;
                            margin-bottom: 14px;
                        }
                        .time{
                            font-size: 9px;
                            line-height: 17px;
                        }
                    }
                }
            }
            .seeMore{
                width:427px;
                height:40px;
                line-height: 40px;
                font-size:13px;
                margin-top: 14px;
                margin-bottom: 73px;
            }
        }
    }

    @media only screen and (max-width: 1440px) and (min-width: 1366px) {
        .centerFloat{
            .textCont{
                width: 900px;
                padding-top: 62px;
                dl{
                    margin-bottom: 23px;
                    dt{
                        width: 300px;
                        height: 150px;
                        margin-right: 24px;
                        img{
                            width: 300px;
                            height: 150px;
                        }
                    }
                    dd{
                        width: 546px;
                        padding-top: 23px;
                        .ddTitle{
                            font-size: 18px;
                            line-height:27px;
                            margin-bottom: 16px;
                        }
                        .contentTextCent{
                            font-size:11px;
                            line-height: 18px;
                            margin-bottom: 15px;
                        }
                        .time{
                            font-size: 9px;
                            line-height: 18px;
                        }
                    }
                }
            }
            .seeMore{
                width: 450px;
                height: 42px;
                line-height: 42px;
                font-size: 14px;
                margin-top: 14px;
                margin-bottom: 77px;
            }
        }
    }
    @media only screen and (max-width: 1680px) and (min-width: 1440px) {
        .centerFloat{
            .textCont{
                width: 1050px;
                padding-top: 73px;
                dl{
                    margin-bottom: 26px;
                    dt{
                        width: 350px;
                        height: 175px;
                        margin-right: 28px;
                        img{
                            width: 350px;
                            height: 175px;
                        }
                    }
                    dd{
                        width: 637px;
                        padding-top: 26px;
                        .ddTitle{
                            font-size: 21px;
                            line-height:32px;
                            margin-bottom: 18px;
                        }
                        .contentTextCent{
                            font-size:12px;
                            line-height: 21px;
                            margin-bottom: 18px;
                        }
                        .time{
                            font-size:11px;
                            line-height: 21px;
                        }
                    }
                }
            }
            .seeMore{
                width: 525px;
                height: 49px;
                font-size: 16px;
                margin-top: 17px;
                margin-bottom: 89px;
                line-height: 49px;
            }
        }
    }
</style>